import { render } from "./DictionaryEditor.vue?vue&type=template&id=2f2e9b94"
import script from "./DictionaryEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/DictionaryEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f2e9b94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f2e9b94', __exports__)) {
    api.reload('2f2e9b94', __exports__)
  }
  
  module.hot.accept("./DictionaryEditor.vue?vue&type=template&id=2f2e9b94", () => {
    api.rerender('2f2e9b94', render)
  })

}


export default __exports__